import ViewportValues from './ViewportValues'
import ScrollHandler from '@/utils/ScrollHandler'
let scrollHandler = new ScrollHandler()
let viewportValues = new ViewportValues()
class ViewportHandler {
  constructor () {
    this._values = {}
    this.listener()
    this._onChange = []
  }

  set onChange (fn) {
    this._onChange.push(fn)
  }

  removeFn (fnToRemove) {
    this._onChange = this._onChange.filter((fn) => {
      return fn !== fnToRemove
    })
  }

  update () {
    let viewport = viewportValues.viewport
    scrollHandler.run()
    for (var i = 0; i < this._onChange.length; i++) {
      this._onChange[i](viewport)
    }
  }

  listener () {
    window.addEventListener('resize', _ => {
      window.requestAnimationFrame(_ => {
        viewportValues.update()
        this.update()
      })
    }, true)
  }
}

let instance = new ViewportHandler()
export default class Singleton {
  constructor () {
    return instance
  }
}



// WEBPACK FOOTER //
// ./src/utils/viewport/ViewportHandler.js